import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { Article } from "../../types/article";

// the list to add is going to be with no 'id' field as it is auto generated
const addOneArticle =
    (article: Article): AppThunk =>
    async (dispatch) => {
        const db = firebase.firestore();
        const docRef = db.collection("articles").doc();

        const currentTimestamp = Date.now();
        const uploadedArticle: Article = {
            ...article,
            id: docRef.id,
            properties: {
                ...article.properties,
                creationTimestamp: currentTimestamp,
                updateTimestamp: currentTimestamp,
            },
        };

        await docRef.set(uploadedArticle);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added one article with name ${article.properties.name?.en}`,
                },
            })
        );

        return;
    };

export default addOneArticle;
